import { DataCell, DataRow, DataTable, DataTableButton } from 'components/basic/DataTable';
import { Input, Form, Label, Container, Row, Col, Button, Collapse, CardBody, Card } from 'reactstrap';
import { saveAs } from 'file-saver';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ConversionReportsClient, ExecutionsClient, ExecutionsModel } from '../../../client/ApiClient';
import { reportsList, miniReportsList, mergeReportsList, ndtReportsList } from './ReportsList';
import * as SourceSystem from 'constants/SourceSystem';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';

import '../../../styles/Forms.scss';

interface IConversionReportsPageProps extends RouteComponentProps<{
    conversionId: string
}> {
    conversionTypeId: string,
    conversionComplete: boolean | undefined,
}

interface IConversionReportsPageState {
    reports: { id: string, name: string, packageName?: string }[];
    buttonLock: boolean;
    reportsFilter: { id: string, name: string, packageName?: string }[];
    hubConnection: HubConnection | null;
}

class ConversionReportsPage extends React.Component<IConversionReportsPageProps, IConversionReportsPageState>{
    private readonly client = new ConversionReportsClient();
    private executions: ExecutionsClient = new ExecutionsClient();
    private conversionId: string = '';


    constructor(props: Readonly<IConversionReportsPageProps>) {
        super(props)
        this.state = {
            reports: [],
            buttonLock: false,
            reportsFilter: [],
            hubConnection: null,
        }
    }

    componentDidMount() {
        this.buttonLock();
        const link = `${process.env.PUBLIC_URL}/executions`
        const hubConnection = new HubConnectionBuilder().withUrl(link).withAutomaticReconnect().build();
        this.setState({ hubConnection }, () => {
            this.state.hubConnection!
                .start()
                .then(() => console.log('Connection started!'))
                .catch(err => console.log('Error while establishing connection :('));

            this.state.hubConnection!.on('Reports', (call: string) => {
                if (this.props.conversionTypeId === SourceSystem.epicToAMS360Id) {
                    this.getExections();
                }
            });
        })
    }

    componentDidUpdate(prevProps: IConversionReportsPageProps) {
        if (this.props.conversionTypeId !== prevProps.conversionTypeId) {
            const reports = this.getReports();
            this.setState({ reports })
            if (this.props.conversionTypeId === SourceSystem.epicToAMS360Id) {
                this.getExections();
            }
        }
    }

    getReports = () => {
        if (this.props.conversionTypeId === SourceSystem.miniToAMS360Id) {
            return miniReportsList
        } else if (SourceSystem.ams360ToAMS360Id === this.props.conversionTypeId) {
            return mergeReportsList
        } else if (SourceSystem.ndtAms360ToAMS360Id === this.props.conversionTypeId) {
            return ndtReportsList
        } else {
            return reportsList;
        }
    }

    exportToExcel = (id: string) => {
        this.client.exportToExcel(this.conversionId, id, null, null)
            .then(response => saveAs(response!.data, response!.fileName))
            .catch(error => { console.log(error) });
    }

    exportToExcelAll = () => {
        try {
            const reports = this.getReports();
            reports.forEach(element => {
                if (this.state.reportsFilter.find(r => r.packageName === element.packageName) || this.props.conversionTypeId !== SourceSystem.epicToAMS360Id) {
                    this.client.exportToExcel(this.conversionId, element.id, null, null)
                        .then(response => saveAs(response!.data, response!.fileName))
                        .catch(error => { console.log(error) })
                }     
            });

            //reports.every(element =>
            //    this.client.exportToExcel(this.conversionId, element.id, null, null)
            //        .then(response => saveAs(response!.data, response!.fileName))
            //        .catch(error => { console.log(error) })
            //);
        } catch (e) { };
    }

    buttonLock = () => {
        this.executions.listExecutionsAllTierBoolean(this.conversionId)
            .then((response) => {
                if (response) this.setState({ buttonLock: response.isLocked })
            })
            .catch(error => { console.log(error) })
    }

    getExections = () => {
        this.executions.listExecutions(this.conversionId)
            .then((response) => {
                if (response) {
                    const reports = this.state.reports
                    const reportsFilter = reports.filter(report =>
                        response.some(r => (report.packageName! === r.packageName && r.status === 7)))
                    this.setState({ reportsFilter })
                }
            })
            .catch(error => { console.log(error) })
    }

    public render() {
        this.conversionId = this.props.match.params.conversionId;
        return (
            <>
                <Row>
                    <Col>
                        <h3 className='mapping-body-header'>
                            Reports
                        </h3>
                    </Col>
                    <Col>
                        <Button
                            className='submit-button-orange float-right'
                            onClick={() => this.exportToExcelAll()}
                            disabled={this.state.buttonLock && !this.props.conversionComplete}>
                            Download all reports
                        </Button>
                    </Col>
                </Row>
                <DataTable>
                    <thead>
                        <tr>
                            <th>Name</th>
                            {(!this.state.buttonLock || this.props.conversionComplete) &&
                                <th className='controls-column'></th>
                            }

                        </tr>
                    </thead>
                    <tbody>
                        {this.state.reports.map(report => (
                            <DataRow id={report.id!} key={report.id}>
                                <DataCell>{report.name}</DataCell>
                                {(((!this.state.buttonLock || this.props.conversionComplete) && this.props.conversionTypeId !== SourceSystem.epicToAMS360Id) || (this.state.reportsFilter.find(r => r.packageName === report.packageName) || report.packageName === '') && this.props.conversionTypeId === SourceSystem.epicToAMS360Id) ?
                                    <DataCell>
                                        <DataTableButton icon='visibility' id={report.id!} title='Run'
                                            action={id => this.props.history.push(`/conversion/${this.conversionId}/reports/${report.id}`)} />
                                        <DataTableButton icon='file_download' id={report.id!} title='Export to Excel'
                                            action={() => this.exportToExcel(report.id!)} />
                                    </DataCell> :
                                    <DataCell>
                                    </DataCell>}
                            </DataRow>
                        ))}
                    </tbody>
                </DataTable>
            </>
        )
    }
}

export default withRouter(ConversionReportsPage)